import { RouteComponentProps } from '@reach/router';
import { PageHero } from '../../components/pageHero/PageHero';
import Page from '../../components/shared/Page';
import { UpdateSchool } from './UpdateSchool';
import { UpdateArchive } from './UpdateArchiveDate';
import placeholderMSAddImage from '../../images/Icon_ManageSchool_01.png';
import placeholderMSArchiveDateImage from '../../images/Icon_ManageSchool_02.png';
import React, { useEffect, useState } from 'react';
import useFetchSchoolDetails from 'hooks/useFetchSchoolDetails';
import { ISchool } from './models';
import Tooltip from 'components/tooltip/Tooltip';
import { WondeLink } from '../../pages/wondeIntegration/WondeLink';
import { WondeIntegration } from '../../pages/wondeIntegration/WondeIntegration';
import { SyncWondeDataResponse } from '../wondeIntegration/models';
import { url } from 'inspector';

export const ManageSchool: React.FC<RouteComponentProps> = () => {
  const [updateIsOpen, setUpdateIsOpen] = useState(false);
  const [dateIsOpen, setDateIsOpen] = useState(false);
  const [schoolDetails, setSchoolDetails] = useState<ISchool | null>(null);
  const [wondeIntegration, setWondeIntegration] = useState<boolean>(false);
  const [selectedSyncType, setSelectedSyncType] = useState<string>("ClassAndPupil");
  const [wondeSchoolId, setWondeSchoolId] = useState<any>(null);
  const [syncResponse, setSyncResponse] = useState<SyncWondeDataResponse | null>(null);

  useEffect(() => {
    if(!wondeIntegration && !updateIsOpen && !dateIsOpen){
      document.body.style.overflowY = '';
    }
  }, [wondeIntegration, updateIsOpen]);

  useFetchSchoolDetails(setSchoolDetails);

  useEffect(() => {
    // If the wonde integration is cancelled reset the sync response
    !wondeIntegration && setSyncResponse(null);
  }, [wondeIntegration]);

  return (
    <Page>
      {wondeIntegration ? 
        <WondeIntegration 
          setWondeIntegration={setWondeIntegration}
          selectedSyncType={selectedSyncType}
          wondeSchoolId={wondeSchoolId}
          syncResponse={syncResponse}
        />
        :
        <div className="PageContent ManageSchoolPage">
          <PageHero title={schoolDetails?.schoolName ?? ''} />
          <div className="WidthContent">
            <div className="ManageSchoolSection Top ManageSchool">
              <div className="FlexLeft">
                <div className="PIColumn">              
                  {schoolDetails && schoolDetails.logoUrl ?
                    <div 
                      className="ProfileSchooLogo"
                      style={{
                        backgroundImage: `url(${schoolDetails.logoUrl})`,
                        backgroundSize: "contain",
                        backgroundPosition: "center center",
                        backgroundRepeat: "no-repeat"
                      }}
                    />
                  :
                    <div className="ProfileImageContainer">
                      <img src={placeholderMSAddImage} alt="Profile" />
                    </div>                  
                  }
                  {schoolDetails && !schoolDetails.logoUrl && 
                    <button
                      className={`Btn BtnLightOrange UploadSchoolLogo`}
                      onClick={() => {
                        setUpdateIsOpen(true);
                      }}
                      disabled={schoolDetails ? false : true}
                    >
                      Upload school logo
                    </button>
                  }                 
                </div>
                <div className="ProfileInfo">
                  <div className="AddressLine1">
                    {schoolDetails?.addressLine1 ?? ''}
                  </div>
                  <div className="AddressLine2">
                    {`${schoolDetails?.addressLine2 ?? ''}
                    ${
                      schoolDetails?.addressLine2 && schoolDetails?.addressLine3
                        ? ', '
                        : ''
                    }
                    ${schoolDetails?.addressLine3 ?? ''}
                    ${
                      schoolDetails?.addressLine3 &&
                      schoolDetails?.postcodeZipcode
                        ? ', '
                        : ''
                    }
                    ${schoolDetails?.postcodeZipcode ?? ''}
                    ${
                      schoolDetails?.postcodeZipcode && schoolDetails?.country
                        ? ', '
                        : ''
                    }
                      ${schoolDetails?.country ?? ''}`}
                  </div>
                </div>
              </div>
              <button
                className={`Btn BtnLightOrange UpdateButton`}
                onClick={() => {
                  setUpdateIsOpen(true);
                }}
                disabled={schoolDetails ? false : true}
              >
                Update school
              </button>
            </div>
            <div className="ManageSchoolSection Top ManageSchool LastBlock">
              <div className="FlexLeft">
                <div className="ProfileImageContainer">
                  <img src={placeholderMSArchiveDateImage} alt="Profile" />
                </div>
                <div className="ProfileInfo">
                  <div className="ArchiveDateLine">
                    <div className="ArchiveDateLine1">
                      Your data will archive on:
                    </div>
                    <Tooltip text="Archiving will move your assessment tables, pupil profile pages and your current curriculum map into your archive. Once archived, you can move and organise your classes for the next academic year. NB: do not move your classes before archiving to ensure no changes are made to your assessments." />
                  </div>

                  <div className="ArchiveDateLine2">
                    {schoolDetails?.yearlyArchivingDate ?? ''}
                  </div>
                </div>
              </div>
              <button
                className={`Btn BtnLightOrange UpdateButton`}
                onClick={() => {
                  setDateIsOpen(true);
                }}
                disabled={schoolDetails ? false : true}
              >
                Or archive now
              </button>
            </div>

            <WondeLink
              setWondeIntegration={setWondeIntegration}
              selectedSyncType={selectedSyncType}
              setSelectedSyncType={setSelectedSyncType}
              wondeIntegration={wondeIntegration} 
              setWondeSchoolId={setWondeSchoolId}
              setSyncResponse={setSyncResponse}
            />
          </div>

          {/* update school form */}
          {updateIsOpen && (
            <UpdateSchool
              panelOpen={updateIsOpen}
              togglePanelOpen={setUpdateIsOpen}
              schoolDetails={schoolDetails}
              setSchoolDetails={setSchoolDetails}
            />
          )}

          {/* update archiving date form */}
          {dateIsOpen && (
            <UpdateArchive
              panelOpen={dateIsOpen}
              togglePanelOpen={setDateIsOpen}
              setSchoolDetails={setSchoolDetails}
            />
          )}
        </div>
      }
    </Page>
  );
};
